// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__132o_","badges":"styles_badges__2AOG0"};